import { createAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from '../constants/sliceName';
import { ExternalLinkBody } from '../interfaces/ExternalLinkBody';

export const getExternalLinks = createAction<string>(`${SLICE_NAME}/getExternalLinks`);
export const createExternalLink = createAction<ExternalLinkBody>(`${SLICE_NAME}/createExternalLink`);
export const updateExternalLink = createAction<ExternalLinkBody>(`${SLICE_NAME}/updateExternalLink`);
export const removeExternalLink = createAction<ExternalLinkBody>(`${SLICE_NAME}/removeExternalLink`);
export const getPipLinks = createAction<string>(`${SLICE_NAME}/getPipLinks`);
